import { AutoComplete, Listbox } from "../../styles/global.style";
import { Control, Controller } from "react-hook-form";
import { FormControl, InputAdornment, InputLabel } from "@mui/material";
import React, { ChangeEvent, useEffect, useState } from "react";

import ExpandDownIcon from "../Icons/ExpandDownIcon";
import ExpandUpIcon from "../Icons/ExpandUpIcon";
import { ILocationSearchPrediction } from "../../services/location/location.interface";
import { InputCustom } from "../../styles/styledComponents";
import Loading from "../Loading/Loading";
import { useDebounce } from "../../hooks";
import { useLocationSearch } from "../../services/location/location.service";

interface AutocompleteLocationSearchProps {
  id?: string;
  onSelect: (breed: ILocationSearchPrediction) => void;
  searchValue: string;
  expand?: boolean | null;
  handleToggleLoctionsFields?: any
  label?: string;
  control?: Control<any>;
  disable?: boolean,
  setShowAddressFields? : any | null;
  setIsBubble?: (value: boolean) => void;
  setIsTextFieldSelected?: (value: boolean) => void;
}

const LocationSearchNew = ({
  id,
  onSelect,
  searchValue,
  expand = null,
  handleToggleLoctionsFields,
  label,
  control,
  disable,
  setShowAddressFields,
  setIsBubble,
  setIsTextFieldSelected,
}: AutocompleteLocationSearchProps) => {
  const [showPrediction, setShowPrediction] = useState(false);
  const [search, setSearch] = useState<string>("");
  // eslint-disable-next-line no-unused-vars
  const [geoLoading, setGeoLoading] = useState(false);
  const { findLocation, locations, loading } = useLocationSearch();
  const debouncedValue = useDebounce<string>(search, 500);

  const handleSelectPlace = (place: ILocationSearchPrediction) => {
    setSearch(place.description);
    setShowPrediction(false);
    onSelect(place);
  };

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setSearch(event.target.value);
    setShowPrediction(true);
  };

  useEffect(() => {
    if (debouncedValue) {
      findLocation(debouncedValue);
    }
  }, [debouncedValue]);

  useEffect(() => {
    setSearch(searchValue);
  }, [searchValue]);

  return (
    <AutoComplete>
      <FormControl className="w-full">
        <InputLabel htmlFor={id} className="w-full flex justify-between items-center !capitalize !font-semibold h-full">
          {label}
          <div className="flex items-center" onClick={handleToggleLoctionsFields}>
            {expand !== null && (
              expand ? <ExpandUpIcon width={20} height={20} /> : <ExpandDownIcon width={20} height={20} />
            )}
          </div>
        </InputLabel>
        <Controller
          name="address"
          control={control}
          render={({ field, fieldState }) => (
            <InputCustom
              id={id}
              type="text"
              placeholder="Address"
              value={search}
              onChange={handleChange}
              onFocus={() => {
                setShowPrediction(true);
                setIsBubble && setIsBubble(false);
                setIsTextFieldSelected && setIsTextFieldSelected(true);
              }}
              onBlur={() => {
                if (!search && !field.value) {
                  setIsTextFieldSelected && setIsTextFieldSelected(false);

                  setShowPrediction(false);
                } else if (!showPrediction && search && field.value!=="") {
                  setIsTextFieldSelected && setIsTextFieldSelected(true);
                }
              }}
              autoComplete="off"
              error={!!fieldState.error}
              helperText={fieldState.error?.message}
              disabled={!disable}
              onFocusCapture={() => setShowAddressFields && setShowAddressFields(true)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    {(loading || geoLoading) && <Loading size={26} />}
                  </InputAdornment>
                ),
              }}
              className="border-2 border-[#E8DFD7] rounded-md"
            />
          )}
        />

        {showPrediction && locations && locations.predictions?.length > 0 && (
          <Listbox>
            {(locations?.predictions).map((place) => (
              <li key={place.place_id} onClick={() => {
                handleSelectPlace(place);
                setIsTextFieldSelected && setIsTextFieldSelected(true);
              }}>
                {place.description}
              </li>
            ))}
          </Listbox>
        )}
      </FormControl>
    </AutoComplete>

  );
};

export default LocationSearchNew;
